var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFsd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 24,
    viewBox: "0 0 52 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.200195,
    width: 51,
    height: 24,
    rx: 8,
    fill: "#191916"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.200195,
    width: 51,
    height: 24,
    rx: 8,
    fill: "#725CE1",
    fillOpacity: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1302 16V7.18H19.3882V8.746H15.0202V10.774H18.9742V12.334H15.0202V16H13.1302ZM24.6162 16.186C22.2102 16.186 21.0162 14.944 20.7822 13.318H22.7202C22.9062 14.218 23.5062 14.764 24.6582 14.764C25.6362 14.764 26.3142 14.392 26.3142 13.672V13.666C26.3142 12.91 25.7202 12.646 24.7722 12.436L23.5122 12.166C21.9282 11.83 20.9382 11.032 20.9382 9.538V9.52C20.9382 8.008 22.3722 6.994 24.3882 6.994C26.4702 6.994 27.6522 7.996 27.9042 9.634H25.9662C25.7562 8.8 25.1922 8.428 24.3042 8.428C23.4582 8.428 22.8342 8.788 22.8342 9.442V9.454C22.8342 10.036 23.2302 10.39 24.0222 10.57L25.2882 10.84C27.1482 11.248 28.2102 11.89 28.2102 13.462V13.474C28.2102 15.22 26.7222 16.186 24.6162 16.186ZM30.3085 16V7.18H33.4405C36.1945 7.18 38.2105 8.632 38.2105 11.596V11.608C38.2105 14.506 36.1945 16 33.4405 16H30.3085ZM32.1985 14.464H33.4105C35.2105 14.464 36.2305 13.492 36.2305 11.608V11.596C36.2305 9.706 35.2105 8.716 33.4105 8.716H32.1985V14.464Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFsd);
export default __webpack_public_path__ + "static/media/fsd.53b406c2e97d337a33a37c3c4f705fb5.svg";
export { ForwardRef as ReactComponent };